import React from "react";

import { Button } from "../../../components/Field";
import { formatAmount } from "../../../helpers/format";
import Title from "../../../components/Title";
import uk from "../../../assets/image/icons/uk.svg"
import usa from "../../../assets/image/icons/usa.svg"

import style from "./style.module.css";

export default function PurchaseButton({ data = {}, uk_price = "", us_price = "" }) {
    const { country, label, url } = data;
    const imageSrc = country === "uk" ? uk : usa;
    const flagClass = country === "uk" ? style.uk : style.usa;
    const getPrice = country === "uk" ? uk_price : us_price;

    return (
        <>
            {
                label !== "" && url !== "" && (
                    <div className={style.flagButton}>
                        <div className={style.priceWrap}>
                        {
                            getPrice && (
                                <Title tag="h4" transform="uppercase" className="fontTeko">{formatAmount(getPrice, country === "uk" ? '£' : '$')}</Title>
                            )
                        }
                        </div>
                        <div className={`${style.flagImage} ${flagClass}`}>
                            <img src={imageSrc} alt="ImageFlag" />
                        </div>
                        <Button link={url} color="buttonPrimary" label={`BUY FROM ${label}`} />
                    </div>
                )
            }
        </>
    )

}